import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";

export default function getGroupTranslationAndIcon(pairedAmenityGroups: PairedSingleAndReturnAmenitiesType) {
    const {
        returnGroup,
        singleGroup,
    } = pairedAmenityGroups

    const {
        translations,
        icon,
    } = singleGroup || returnGroup

    return {
        translations,
        icon,
    }
}